import(/* webpackMode: "eager" */ "/vercel/path0/src/app/services/virtual-renovation/page.tsx");
